module.exports = __webpack_public_path__ + "static/candle-product-da7f905a95fa22d638430649daf275da.jpeg";